module.exports = __webpack_public_path__ + "img/image_add_btn.7f93622a.svg";